import React from "react";
import { motion } from "framer-motion";

import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
} from "@mui/material/";
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';

const experiences = [
  {
    date: "October 2024 - Present",
    role: "Mencerdaskan Anak Bangsa",
    company: "Tridaya Sejahtera Group",
    type: "industry",
    icon: <WorkIcon />
  },
  {
    date: "April 2024 - September 2024",
    role: "Software Engineering Intern",
    company: "Infront Consulting Group Malaysia Sdn Bhd",
    type: "industry",
    icon: <WorkIcon />
  },
  {
    date: "2020 - 2024",
    role: "B.Sc. in Information Technology",
    company: "Universiti Utara Malaysia",
    type: "education",
    icon: <SchoolIcon />
  }
];

export default function Experiences() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
    }
  };

  return (
    <Box
      id="experiences"
      sx={{
        py: { xs: 8, md: 12 },
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        <Box mb={6}>
          <Typography variant="h2" sx={{ color: "text.primary", mb: 2 }}>
            Experience
          </Typography>
        </Box>

        <Box
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <Typography variant="h4" sx={{ color: "text.primary", mb: 3, mt: 4 }}>Industry</Typography>
          <Grid container spacing={3} sx={{ mb: 6 }}>
            {experiences.filter(exp => exp.type === 'industry').map((exp, index) => (
              <Grid item xs={12} md={6} key={index}>
                <motion.div variants={itemVariants} style={{ height: "100%" }}>
                  <Card 
                    sx={{ 
                      p: 4, 
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      position: "relative",
                      overflow: "hidden"
                    }}
                  >
                    {/* Background Icon Watermark */}
                    <Box 
                      aria-hidden="true"
                      sx={{ 
                        position: "absolute", 
                        right: -20, 
                        bottom: -20, 
                        opacity: 0.03, 
                        transform: "scale(5)",
                        pointerEvents: "none"
                      }}
                    >
                      {exp.icon}
                    </Box>

                    <Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                        <Box 
                          aria-hidden="true"
                          sx={(theme) => ({ 
                            p: 1.5, 
                            borderRadius: "12px", 
                            bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
                            color: "primary.main",
                            display: "flex"
                          })}
                        >
                          {exp.icon}
                        </Box>
                        <Typography variant="h6" sx={{ color: "text.secondary" }}>
                          {exp.date}
                        </Typography>
                      </Box>
                      
                      <Typography variant="h4" sx={{ color: "text.primary", mb: 1 }}>
                        {exp.role}
                      </Typography>
                      <Typography variant="body1" sx={{ color: "text.secondary", fontSize: "1.125rem" }}>
                        {exp.company}
                      </Typography>
                    </Box>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>

          <Typography variant="h4" sx={{ color: "text.primary", mb: 3 }}>Education</Typography>
          <Grid container spacing={3}>
            {experiences.filter(exp => exp.type === 'education').map((exp, index) => (
              <Grid item xs={12} md={6} key={index}>
                <motion.div variants={itemVariants} style={{ height: "100%" }}>
                  <Card 
                    sx={{ 
                      p: 4, 
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      position: "relative",
                      overflow: "hidden"
                    }}
                  >
                    {/* Background Icon Watermark */}
                    <Box 
                      aria-hidden="true"
                      sx={{ 
                        position: "absolute", 
                        right: -20, 
                        bottom: -20, 
                        opacity: 0.03, 
                        transform: "scale(5)",
                        pointerEvents: "none"
                      }}
                    >
                      {exp.icon}
                    </Box>

                    <Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                        <Box 
                          aria-hidden="true"
                          sx={(theme) => ({ 
                            p: 1.5, 
                            borderRadius: "12px", 
                            bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
                            color: "primary.main",
                            display: "flex"
                          })}
                        >
                          {exp.icon}
                        </Box>
                        <Typography variant="h6" sx={{ color: "text.secondary" }}>
                          {exp.date}
                        </Typography>
                      </Box>
                      
                      <Typography variant="h4" sx={{ color: "text.primary", mb: 1 }}>
                        {exp.role}
                      </Typography>
                      <Typography variant="body1" sx={{ color: "text.secondary", fontSize: "1.125rem" }}>
                        {exp.company}
                      </Typography>
                    </Box>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
